import { Box, Grid2, Typography } from '@mui/material'
import React from 'react'
import { Constants, Page_Padding } from '../../shared/constants';
import CustomDivider from '../../shared/utils/CustomDivider';
import ReviewRatingCom from '../../shared/components/ReviewRatingCom';
import { ReviewRating } from '../Courses/ReviewRating';
import EventSubscribeCard from './EventSubscribeCard';
import HorizontalScroll from '../../shared/components/HorizontalScroll';
import { useParams } from 'react-router-dom';
import { useEventDetail } from '../../assets/api/useGetApi';
import { SkeletonCom } from '../../shared/utils/SkeletonCom';
import LatestEventCard from '../../shared/components/LatestEventCard';
import EventCarousel from './EventCarousel';
import useResponsive from '../../shared/utils/Responsive';

const EventDetail = () => {
    
    const { id } = useParams();
    const { data: eventDetail, isLoading } = useEventDetail(id);
    const isSmallScreen = useResponsive("md")
    const renderEventCards = () =>
        !isLoading
            ? eventDetail?.related_events?.map((item, index) => (
                <Grid2
                    children
                    key={index}
                    size={{ xs: 12, sm: 5.7, lg: 3.7 }}
                    sx={{ flex: "0 0 auto", display: "flex", alignItems: "stretch" }}
                >
                    <LatestEventCard item={item}/>
                </Grid2>
            ))
            : [...Array(6)].map((_, index) => (
                <Grid2 children key={index} size={{ xs: 12, sm: 5.7, lg: 3.7 }} sx={{ flex: "0 0 auto" }}>
                    <SkeletonCom />
                </Grid2>
            ));
    const itemData = [
        { img: `https://stage.myskool.club/events/assets/admin/img/event-gallery/${eventDetail?.data?.event_images[0]}`, title: 'Image 1' },
        { img: Constants.customImages.CourseDetailImg1, title: 'Image 2' },
        { img: Constants.customImages.CourseDetailImg2, title: 'Image 3' }
    ];

    return (
        <Box className="body course_detail" px={Page_Padding}>
            <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, sm: 8 }}>
                    {eventDetail?.data?.event_images.length > 1 ? <EventCarousel slides={eventDetail?.data?.event_images} /> : <img
                        src={itemData[0].img}
                        alt={itemData[0].title}
                        width="100%"
                        style={{ objectFit: "cover", height:isSmallScreen?"260px":"400px" }}
                    />}


                </Grid2>
                <Grid2 container size={{ xs: 12, sm: 4 }} spacing={2}>
                    {itemData.slice(1).map((item, index) => (
                        <Grid2 key={index} size={{ xs: 6, sm: 12 }}>
                            <img
                                src={item.img}
                                alt={item.title}
                                width="100%"
                                style={{ objectFit: "cover", maxHeight: "190px" }} 
                            />
                        </Grid2>
                    ))}
                </Grid2>
            </Grid2>
            <CustomDivider orientation='horizontal' />
            <EventSubscribeCard />
            <CustomDivider orientation='horizontal' />
            {eventDetail?.related_events?.length <= 3 ? (
                <>
                    <Typography variant="h5" my={3}> Related Event </Typography>
                    <Grid2 container spacing={"30px"}>{renderEventCards()}</Grid2>
                </>

            ) : (
                <>
                    <Typography variant="h5" mb={"-35px"}> Related Event </Typography>
                    <HorizontalScroll size={3}>{renderEventCards()}</HorizontalScroll>
                </>

            )}

            <CustomDivider orientation='horizontal' />
            

            <Typography variant="h5" >Review & Rating</Typography>
            {Array.from({ length: 3 }).map((_, index) => (
                <ReviewRatingCom key={index} />
            ))}
            <CustomDivider orientation='horizontal' />
            <ReviewRating />
        </Box>
    )
}

export default EventDetail